/* NEWSED collection UI v1.23. v1.20 visuals and panel behavior; explicit lifecycle API added for async data. */
(function () {
  'use strict';
  if (window.NewsedCollectionUI && window.NewsedCollectionUI.version === '1.23.0') {
    window.NewsedCollectionUI.init(document);
    return;
  }
  var controllers = new Map();
  var currentController = null;

  function initRoot(root) {
    if (controllers.has(root)) return;
    var body = document.body;
    var html = document.documentElement;
    var panels = {
      filter: root.querySelector('[data-newsed-filter-drawer]'),
      sort: root.querySelector('[data-newsed-sort-sheet]')
    };
    var triggers = {
      filter: root.querySelector('[data-newsed-filter-open]'),
      sort: root.querySelector('[data-newsed-sort-open]')
    };
    var moreFilterTriggers = Array.from(root.querySelectorAll('[data-newsed-filter-more-open]'));
    var form = root.querySelector('[data-newsed-filter-form]');
    var active = null;
    var previousFocus = null;
    var draftSnapshot = [];
    var inerted = [];
    var scrollState = null;
    var removers = [];
    var disposed = false;
    var frame = 0;
    var trackUntil = 0;
    var header = null;
    var headerObserver = null;
    var headerResize = null;
    var visualViewport = window.visualViewport;
    var inputStates = new WeakMap();
    var applyActivation = false;
    var applyResetTimer = 0;
    var viewportRecoveryFrame = 0;
    var viewportRecoveryTimers = [];

    function listen(target, type, fn, options) {
      if (!target) return;
      target.addEventListener(type, fn, options);
      removers.push(function () { target.removeEventListener(type, fn, options); });
    }
    function setVar(name, value) {
      if (root.style.getPropertyValue(name) !== value) root.style.setProperty(name, value);
    }
    function schedule() {
      if (!disposed && !frame) frame = requestAnimationFrame(measure);
    }
    function headerChanged() {
      // A transform transition can continue after the class/scroll event.
      trackUntil = performance.now() + 700;
      schedule();
    }
    function bindHeader() {
      var next = document.querySelector('.newsed-header-stack') || document.querySelector('.newsed-header');
      if (next === header) return;
      if (headerObserver) headerObserver.disconnect();
      if (headerResize) headerResize.disconnect();
      header = next;
      if (!header) return;
      if (window.ResizeObserver) {
        headerResize = new ResizeObserver(schedule);
        headerResize.observe(header);
      }
      if (window.MutationObserver) {
        headerObserver = new MutationObserver(headerChanged);
        headerObserver.observe(header, { attributes: true, childList: true, subtree: true,
          attributeFilter: ['class', 'style', 'hidden'] });
        // Covers a class-driven hide on the Shopify wrapper as well as the header itself.
        var parent = header.parentElement;
        while (parent) {
          headerObserver.observe(parent, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
          parent = parent.parentElement;
        }
      }
    }
    function visibleHeaderBottom() {
      if (!header || !header.getClientRects().length) return 0;
      var node = header;
      while (node && node !== body) {
        var css = getComputedStyle(node);
        if (css.display === 'none' || css.visibility === 'hidden' || Number(css.opacity) === 0) return 0;
        node = node.parentElement;
      }
      var box = header.getBoundingClientRect();
      if (box.top >= window.innerHeight || box.bottom <= 0) return 0;
      return Math.max(0, box.bottom);
    }
    function measure() {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      if (disposed) return;
      bindHeader();
      // Do not measure the frozen document as if its header had moved on opening a panel.
      if (!active) setVar('--newsed-collection-header-bottom', visibleHeaderBottom().toFixed(2) + 'px');
      // Avoid fighting pinch zoom; only track keyboard/browser chrome at normal scale.
      if (active === 'filter' && isFilterInput(document.activeElement) &&
          visualViewport && Math.abs(visualViewport.scale - 1) < 0.01) {
        setVar('--newsed-drawer-height', Math.max(1, visualViewport.height).toFixed(2) + 'px');
        setVar('--newsed-drawer-top', Math.max(0, visualViewport.offsetTop).toFixed(2) + 'px');
      } else {
        root.style.removeProperty('--newsed-drawer-height');
        root.style.removeProperty('--newsed-drawer-top');
      }
      revealFilterInput();
      if (performance.now() < trackUntil) schedule();
    }

    function isFilterInput(input) {
      return !!(input && form && form.contains(input) && input.matches &&
        input.matches('[data-newsed-filter-search],[data-price-min-input],[data-price-max-input]'));
    }
    function revealFilterInput() {
      var input = document.activeElement;
      if (active !== 'filter' || !isFilterInput(input) ||
          (visualViewport && Math.abs(visualViewport.scale - 1) >= 0.01)) return;
      var scroll = input.closest('.newsed-filter-scroll');
      if (!scroll) return;
      var area = scroll.getBoundingClientRect();
      var box = input.getBoundingClientRect();
      var top = area.top + 12;
      var bottom = area.bottom - 12;
      if (bottom - top < box.height) return;
      var room = input.hasAttribute('data-newsed-filter-search') ? Math.min(96, bottom - top - box.height) : 0;
      if (box.top < top) scroll.scrollTop += box.top - top;
      else if (box.bottom > bottom - room) scroll.scrollTop += box.bottom - bottom + room;
    }
    function finishInput(input) {
      if (!isFilterInput(input)) return;
      var state = inputStates.get(input);
      if (state && (state.composing || state.imeKey)) return;
      if (input.hasAttribute('data-newsed-filter-search')) filterSearch(input);
      input.blur();
      if (active === 'filter') panels.filter.focus({ preventScroll: true });
      measure();
      schedule();
    }
    function cancelViewportRecovery() {
      if (viewportRecoveryFrame) cancelAnimationFrame(viewportRecoveryFrame);
      viewportRecoveryFrame = 0;
      viewportRecoveryTimers.forEach(clearTimeout);
      viewportRecoveryTimers = [];
    }
    function recoverViewport() {
      if (disposed || active !== 'filter' || !scrollState || isFilterInput(document.activeElement) ||
          (visualViewport && Math.abs(visualViewport.scale - 1) >= 0.01)) return;
      root.style.removeProperty('--newsed-drawer-height');
      root.style.removeProperty('--newsed-drawer-top');
      var behavior = saveStyles(html, ['scroll-behavior']);
      html.style.setProperty('scroll-behavior', 'auto', 'important');
      html.scrollTop = 0;
      body.scrollTop = 0;
      window.scrollTo({ left: 0, top: 0, behavior: 'instant' });
      restoreStyles(html, behavior);
    }
    function scheduleViewportRecovery() {
      cancelViewportRecovery();
      if (active !== 'filter') return;
      viewportRecoveryFrame = requestAnimationFrame(function () {
        viewportRecoveryFrame = 0;
        recoverViewport();
        measure();
      });
      viewportRecoveryTimers = [150, 400].map(function (delay) {
        return setTimeout(function () { recoverViewport(); schedule(); }, delay);
      });
    }

    function saveStyles(el, names) {
      return names.map(function (name) {
        return [name, el.style.getPropertyValue(name), el.style.getPropertyPriority(name)];
      });
    }
    function restoreStyles(el, values) {
      values.forEach(function (item) {
        if (item[1]) el.style.setProperty(item[0], item[1], item[2]);
        else el.style.removeProperty(item[0]);
      });
    }
    function lockScroll() {
      if (scrollState) return;
      var scrollbar = Math.max(0, window.innerWidth - html.clientWidth);
      var padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
      scrollState = { x: window.scrollX, y: window.scrollY,
        body: saveStyles(body, ['position', 'top', 'left', 'width', 'overflow', 'padding-right']),
        html: saveStyles(html, ['overflow', 'scroll-behavior']) };
      body.style.position = 'fixed';
      body.style.top = -scrollState.y + 'px';
      body.style.left = -scrollState.x + 'px';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      if (scrollbar) body.style.paddingRight = (padding + scrollbar) + 'px';
      html.style.overflow = 'hidden';
    }
    function unlockScroll() {
      if (!scrollState) return;
      var saved = scrollState;
      scrollState = null;
      restoreStyles(body, saved.body);
      restoreStyles(html, saved.html);
      // The base theme has smooth scrolling. Restoration must be synchronous, not animated.
      html.style.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
      restoreStyles(html, saved.html);
    }
    function releaseBackground() {
      inerted.forEach(function (el) { el.removeAttribute('inert'); });
      inerted = [];
    }
    function isolatePanel(panel) {
      var node = panel;
      while (node && node !== body) {
        var parent = node.parentElement;
        if (!parent) break;
        Array.prototype.forEach.call(parent.children, function (sibling) {
          if (sibling === node || sibling.matches('script,style,link,.newsed-drawer-backdrop,.newsed-sort-backdrop') || sibling.hasAttribute('inert')) return;
          sibling.setAttribute('inert', '');
          inerted.push(sibling);
        });
        node = parent;
      }
    }
    function focusable(panel) {
      return Array.prototype.filter.call(panel.querySelectorAll(
        'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])'
      ), function (el) {
        return el.tabIndex >= 0 && !el.closest('[inert],[hidden]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
      });
    }
    function focusFirst(panel) {
      var first = panel.querySelector('.newsed-drawer-close') || focusable(panel)[0] || panel;
      first.focus({ preventScroll: true });
    }
    function snapshotDraft() {
      draftSnapshot = form ? Array.prototype.map.call(form.elements, function (el) {
        return { el: el, value: el.value, checked: el.checked };
      }) : [];
    }
    function updateFilterOptions(group) {
      if (!group) return;
      var input = group.querySelector('[data-newsed-filter-search]');
      var query = input ? input.value.trim().toLowerCase() : '';
      var limit = Number(group.getAttribute('data-newsed-filter-limit')) || 0;
      var expanded = group.getAttribute('data-newsed-filter-expanded') === 'true';
      var rows = group.querySelectorAll('[data-filter-option]');
      var matches = 0;
      rows.forEach(function (row, index) {
        var match = !query || (row.getAttribute('data-filter-text') || '').indexOf(query) !== -1;
        var checked = limit && row.querySelector('input[type="checkbox"]:checked');
        if (match) matches++;
        row.hidden = !checked && (!match || (!query && limit && !expanded && index >= limit));
      });
      var more = group.querySelector('[data-newsed-filter-more]');
      if (more) {
        more.hidden = !!query || rows.length <= limit;
        more.setAttribute('aria-expanded', String(expanded));
        more.textContent = expanded ? limit + '件に戻す' : 'すべて表示（' + rows.length + '）';
      }
      var empty = group.querySelector('[data-newsed-filter-search-empty]');
      if (empty) empty.hidden = !query || matches > 0;
    }
    function filterSearch(input) {
      updateFilterOptions(input.closest('.newsed-filter-group'));
    }
    function discardDraft() {
      draftSnapshot.forEach(function (item) {
        item.el.value = item.value;
        if (typeof item.checked === 'boolean') item.el.checked = item.checked;
      });
      root.querySelectorAll('[data-newsed-filter-search]').forEach(filterSearch);
      draftSnapshot = [];
      syncBudgetPresets();
    }
    function close(restoreFocus) {
      if (!active) return;
      cancelViewportRecovery();
      var kind = active;
      var panel = panels[kind];
      active = null;
      if (currentController === controller) currentController = null;
      if (kind === 'filter') discardDraft();
      releaseBackground();
      if (panel.contains(document.activeElement)) document.activeElement.blur();
      panel.setAttribute('inert', '');
      panel.setAttribute('aria-hidden', 'true');
      triggers[kind].setAttribute('aria-expanded', 'false');
      if (kind === 'filter') moreFilterTriggers.forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
      body.classList.remove('newsed-filter-open', 'newsed-sort-open');
      unlockScroll();
      // Update the sticky position before restoring focus, without changing page scroll.
      measure();
      if (restoreFocus !== false && previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
      previousFocus = null;
    }
    function open(kind, trigger) {
      if (disposed || !panels[kind] || !triggers[kind] || active === kind) return;
      if (currentController) currentController.close(false);
      previousFocus = trigger || triggers[kind];
      if (kind === 'filter') snapshotDraft();
      // Capture before position:fixed changes document scroll metrics.
      measure();
      lockScroll();
      active = kind;
      currentController = controller;
      panels[kind].removeAttribute('inert');
      panels[kind].setAttribute('aria-hidden', 'false');
      triggers[kind].setAttribute('aria-expanded', 'true');
      if (kind === 'filter') moreFilterTriggers.forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
      body.classList.add('newsed-' + kind + '-open');
      focusFirst(panels[kind]);
      isolatePanel(panels[kind]);
      schedule();
    }
    var controller = {
      open: open, close: close, refresh: schedule,
      destroy: function () {
        close(false);
        disposed = true;
        if (frame) cancelAnimationFrame(frame);
        clearTimeout(applyResetTimer);
        cancelViewportRecovery();
        if (headerObserver) headerObserver.disconnect();
        if (headerResize) headerResize.disconnect();
        removers.forEach(function (remove) { remove(); });
        root.style.removeProperty('--newsed-collection-header-bottom');
        root.style.removeProperty('--newsed-drawer-height');
        root.style.removeProperty('--newsed-drawer-top');
        controllers.delete(root);
      }
    };
    controllers.set(root, controller);

    listen(triggers.filter, 'click', function () { open('filter'); });
    moreFilterTriggers.forEach(function (button) {
      if (panels.filter) button.setAttribute('aria-controls', panels.filter.id);
      listen(button, 'click', function () {
        if (!button.disabled && triggers.filter && !triggers.filter.disabled) open('filter', button);
      });
    });
    listen(triggers.sort, 'click', function () { open('sort'); });
    root.querySelectorAll('[data-newsed-filter-close],[data-newsed-sort-close]').forEach(function (el) {
      listen(el, 'click', function () { close(); });
    });
    listen(document, 'keydown', function (event) {
      if (!active) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      var panel = panels[active];
      var items = focusable(panel);
      if (!items.length) { event.preventDefault(); panel.focus({ preventScroll: true }); return; }
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
        event.preventDefault(); last.focus({ preventScroll: true });
      } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
        event.preventDefault(); first.focus({ preventScroll: true });
      }
    });
    listen(document, 'focusin', function (event) {
      if (active && !panels[active].contains(event.target)) focusFirst(panels[active]);
    });
    root.querySelectorAll('[data-newsed-filter-search],[data-price-min-input],[data-price-max-input]').forEach(function (input) {
      var state = { composing: false, imeKey: false };
      var search = input.hasAttribute('data-newsed-filter-search');
      inputStates.set(input, state);
      input.setAttribute('enterkeyhint', search ? 'search' : 'done');
      listen(input, 'focus', function () { cancelViewportRecovery(); schedule(); });
      listen(input, 'compositionstart', function () { state.composing = true; });
      listen(input, 'compositionend', function () {
        state.composing = false;
        if (search) filterSearch(input);
        schedule();
      });
      listen(input, 'input', function (event) {
        if (search && !state.composing && !event.isComposing) filterSearch(input);
        schedule();
      });
      listen(input, 'keydown', function (event) {
        state.imeKey = state.composing || event.isComposing || event.keyCode === 229;
        if (event.key !== 'Enter' || state.imeKey) return;
        event.preventDefault();
        event.stopPropagation();
        finishInput(input);
      });
      listen(input, 'keyup', function () { state.imeKey = false; });
      listen(input, 'blur', function () {
        state.composing = false;
        state.imeKey = false;
        scheduleViewportRecovery();
      });
      if (search) listen(input, 'search', function () {
        if (state.composing || state.imeKey) return;
        filterSearch(input);
        if (input.value.trim()) finishInput(input);
      });
    });
    listen(form, 'click', function (event) {
      var button = event.target.closest('button[type="submit"],input[type="submit"]');
      if (!button || !form.contains(button)) return;
      if (event.detail === 0 && isFilterInput(document.activeElement)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        finishInput(document.activeElement);
        return;
      }
      applyActivation = true;
      clearTimeout(applyResetTimer);
      applyResetTimer = setTimeout(function () { applyActivation = false; }, 0);
    }, true);
    listen(form, 'submit', function (event) {
      if (applyActivation) { applyActivation = false; clearTimeout(applyResetTimer); return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      finishInput(document.activeElement);
    }, true);
    root.querySelectorAll('[data-newsed-filter-limit]').forEach(function (group) {
      var more = group.querySelector('[data-newsed-filter-more]');
      if (more) listen(more, 'click', function () {
        var expanded = group.getAttribute('data-newsed-filter-expanded') === 'true';
        group.setAttribute('data-newsed-filter-expanded', String(!expanded));
        updateFilterOptions(group);
        if (expanded) {
          var input = group.querySelector('[data-newsed-filter-search]');
          if (input) input.focus({ preventScroll: true });
          group.scrollIntoView({ block: 'nearest' });
        }
      });
      listen(group, 'change', function (event) {
        if (event.target.matches('input[type="checkbox"]')) updateFilterOptions(group);
      });
      updateFilterOptions(group);
    });
    function isBudgetPresetSelected(button, min, max) {
      var noMinimum = !min || min.value.trim() === '' || Number(min.value) === 0;
      return !!max && max.value.trim() !== '' && noMinimum &&
        Number(max.value) === Number(button.getAttribute('data-price-max'));
    }
    function syncBudgetPresets() {
      root.querySelectorAll('[data-price-max]').forEach(function (button) {
        var group = button.closest('.newsed-filter-group');
        var min = group && group.querySelector('[data-price-min-input]');
        var max = group && group.querySelector('[data-price-max-input]');
        var selected = isBudgetPresetSelected(button, min, max);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }
    root.querySelectorAll('[data-price-max]').forEach(function (button) {
      listen(button, 'click', function () {
        var group = button.closest('.newsed-filter-group');
        var min = group && group.querySelector('[data-price-min-input]');
        var max = group && group.querySelector('[data-price-max-input]');
        if (!max) return;
        var selected = isBudgetPresetSelected(button, min, max);
        if (min) min.value = '';
        max.value = selected ? '' : button.getAttribute('data-price-max');
        // Do not focus a text input: tapping a preset should not open a mobile keyboard.
        syncBudgetPresets();
      });
    });
    root.querySelectorAll('[data-price-min-input],[data-price-max-input]').forEach(function (input) {
      listen(input, 'input', syncBudgetPresets);
      listen(input, 'change', syncBudgetPresets);
    });
    syncBudgetPresets();
    listen(window, 'scroll', schedule, { passive: true });
    listen(window, 'resize', schedule, { passive: true });
    listen(visualViewport, 'resize', schedule, { passive: true });
    listen(visualViewport, 'scroll', schedule, { passive: true });
    listen(window, 'pagehide', function () { close(false); });
    listen(window, 'pageshow', function () { close(false); schedule(); });
    listen(document, 'transitionrun', function (event) {
      if (header && (header.contains(event.target) || event.target.contains(header))) headerChanged();
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    measure();
  }
  function init(container) {
    if (container.matches && container.matches('[data-newsed-collection]')) initRoot(container);
    container.querySelectorAll('[data-newsed-collection]').forEach(initRoot);
    controllers.forEach(function (controller) { controller.refresh(); });
  }
  window.NewsedCollectionUI = { version: '1.23.0', init: init, destroy: function (root) { var c = controllers.get(root); if (c) c.destroy(); }, close: function (root) { var c = controllers.get(root); if (c) c.close(false); } };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (controller, root) {
      if (event.target === root || event.target.contains(root)) controller.destroy();
      else controller.refresh();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
})();
